import { render, staticRenderFns } from "./payment-config.vue?vue&type=template&id=1ee3783c&scoped=true"
import script from "./payment-config.vue?vue&type=script&lang=js"
export * from "./payment-config.vue?vue&type=script&lang=js"
import style0 from "./payment-config.vue?vue&type=style&index=0&id=1ee3783c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee3783c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ee3783c')) {
      api.createRecord('1ee3783c', component.options)
    } else {
      api.reload('1ee3783c', component.options)
    }
    module.hot.accept("./payment-config.vue?vue&type=template&id=1ee3783c&scoped=true", function () {
      api.rerender('1ee3783c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/payment-config.vue"
export default component.exports